module.exports = __webpack_public_path__ + "static/img/应用效果1-单毫米波.9b5fa25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/应用效果1-单毫米波.png
// module id = 3aPT
// module chunks = 0